import Dialog from "@mui/material/Dialog";
import styled from "styled-components";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { FlexAlignWrapper, flexAlign } from "@/components/css.common";

export const messageTheme = createTheme({
  components: {
    MuiSnackbar: {
      styleOverrides: {
        root: {
          transition: 'all .3s ease-out 0s',
          position: 'relative',
          left: '0!important',
          top: '0!important',
          transform: 'scale(1)!important',
          overflow: 'hidden',
          //   marginLeft: "122px",

          "&.start": {
            marginTop: '100px',
            transform: 'scale(0.3)!important'
          },

          '&.scale0': {
            transform: 'scale(0)!important',
          },

          "& .MuiSnackbarContent-root": {
            minWidth: "0",
            maxWidth: '88vw',
            boxSizing: 'border-box',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: "6px min(5.33vw, 32px)!important",
          borderRadius: '8px!important',
          backgroundColor: '#525252!important',
          boxShadow: 'none!important',
        },
      },
    }
  },
});

export const MessageContent = styled(FlexAlignWrapper)`

  i {
    margin-right: 15px;
    background-repeat: no-repeat;
    flex-shrink: 0;
  }

  span {
    ${flexAlign};
  }
`;
